import { render } from "./physiotherapy_history.vue?vue&type=template&id=53f957a8&scoped=true"
import script from "./physiotherapy_history.vue?vue&type=script&lang=js"
export * from "./physiotherapy_history.vue?vue&type=script&lang=js"

import "./physiotherapy_history.vue?vue&type=style&index=0&id=53f957a8&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f957a8"]])

export default __exports__